'use strict';

import { base, log, Component, PropTypes, update, sub, fromJS, toJS, mq, ReactChildren, Listener, redirect } from 'core';

import { Paper } from 'material-ui';

import { Masonry } from 'masonry';

import HSSection from 'c/layout/hsLayout/section';
import PageWrapper from 'c/layout/pageWrapper';

import Card from 'c/card/product';

import $style from './style';

const filterCards = function (key) {

    return this('cards').toOrderedMap()
        .filter(card => card.get('section') == key)
        .sort((a, b) => a.get('id') > b.get('id'))
        .toArray()
}

@base({
    track: [['cards']]
})
class Section extends Component {

    render() {

        const { get, sub } = this._store();

        const { cards: _cards, layout, columns } = this.props;
        const cards = _cards.sort((a, b) => a.get('id') - b.get('id'));

        const gridCards = layout.map((grid, i) => (cards[i]) ?
            <Card key={`p:${i}:${cards[i].get('id')}`} columns={columns}
                {...this._sub('cards', `${cards[i].get('id')}`)}
                {...grid} /> :
            <Card key={`r:${i}`} {...grid} {...sub('cards', `raw`)} columns={columns} />);

        const section =
            <Masonry items={gridCards} />;

        return (
            <HSSection>
                {section}
            </HSSection>
        );
    }
}

const initialRect = window.document
    .getElementsByTagName('react')[0]
    .getBoundingClientRect();

@base({
    track: [['sections']],
    bind: {
        'document:resize': ($, rect) => $.setState(rect)
    }
})
class Sections extends Component {

    state = { width: initialRect.width }

    render() {

        const { width, height } = this.state || {};

        const sections = this._get('pages', `${this.props.page}`, 'sections');

        let sectionsMap = sections.map((section) => {

            const { key = 'home', layout: regular_layout, tablet: tablet_layout } = this._get('sections', `${section}`).toJS();
            const layout_key = (width < 900 && width > 500) ? tablet_layout : regular_layout;

            let layout = this._get('layouts', `${layout_key}`).toJS().layout;
            let cards = this._get:: filterCards(key);

            return { cards, layout }
        }).toJS();

        let columns = 8;

        log.bold('  sections', toJS(sections));

        /* Join sections for vertical layout */
        if (width < 900) {

            sectionsMap = [
                sectionsMap.reduce((list, section) => ({
                    cards: [...list.cards, ...section.cards],
                    layout: [...list.layout, ...section.layout],
                }), { cards: [], layout: [] })
            ];

            columns = 5;
        }
        if (width < 500) {

            columns = 1;
        }

        console.log(sectionsMap);

        return (
            <div className="sections-size" style={{ height: '100%' }}>
                {sectionsMap.map((section, i) =>
                    <Section key={`s:${columns}:${i}`} {...section} columns={columns} />
                )}
            </div>
        );
    }
}

@base({
    styles: [$style],
    track: [['router', 'location']]
})
class Home extends Component {

    render() {

        const page = (window.location.pathname)
            .split('/')
            .filter(c => c != '')
            .shift() || 'home';

        log.bold('  defaultHandler', page);

        return (
            <PageWrapper className="page">
                <Sections page={page} />
            </PageWrapper>
        );
    }
};

export default Home



// WEBPACK FOOTER //
// ./ui/c/home/index.jsx